<template lang="pug">
.page-top-area.fixed-top
.relative-position.info-mobile.adv-wrapper
    header-mobile
        template(v-slot:leftIcon)
            q-icon.q-mr-sm.q-py-xs.q-pl-xs.q-pr-sm(
                name="etabl:arrow_prev"
                color="positive"
                size="xs"
                @click="goBack")
        template(v-slot:title)
            h1.font-14.text-positive.text-weight-bold(@click="goBack") Акции
    .q-mx-md(v-for="item in modifyAdvert")
        .font-14.q-mt-md.q-mb-sm.text-positive.text-weight-medium {{ item.title }}
        q-img.cursor-pointer.b-radius-10(:src="item.image" @click="goTo(item.url ? item.url : `/marketing/${item.id}?token=${item.token}`)" no-spinner style="max-height: 280px;")
            .adv-badge.flex.items-center(@click.prevent.stop="showModal(item)" v-if="item.token")
                q-icon(
                    name="etabl:info_warning"
                    size="14px"
                    color="primary"
                )
                span.font-12.text-primary(style="margin-left: 2px")
                    | Реклама
q-dialog(
    :model-value="showAdvModal"
    full-width
    position="bottom"
    transition-show="slide-up"
    transition-hide="slide-down"
    @hide="showAdvModal = false")
    .full-width.full-height.bg-secondary.b-radius-0.relative-position.q-pt-lg.q-px-md.bottom-popup-mobile
        .text-primary.text-center
            |  {{ activeAdv.organizationName }}, ИНН {{ activeAdv.inn }}
        base-btn.q-mt-md(
            label="Скопировать ссылку"
            @click="copy(`https://etabl.ru/marketing/${activeAdv.id}?token=${activeAdv.token}`)"
        )
        base-btn(
            label="Понятно"
            @click="showAdvModal = false"
        ).q-my-md
base-button-top-mobile
</template>

<script>
import { computed, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { copyToClipboard } from 'quasar';
import HeaderMobile from 'components/Header/HeaderMobile.vue';
import BaseButtonTopMobile from 'components/Base/BaseButtonTopMobile.vue';
import BaseBtn from 'src/components/Base/BaseBtn.vue';

export default {
    name: 'MarketingListDesktop',
    components: {
        HeaderMobile,
        BaseButtonTopMobile,
        BaseBtn,
    },
    setup() {
        const router = useRouter();
        const store = useStore();

        const activeAdv = ref(null);
        const showAdvModal = ref(false);
        const modifyAdvert = ref([]);

        // город пользователя
        const city = computed(() => store.getters['cityForm/CITY']);

        const advertisment = computed(() => store.getters['advertisement/ADVERTISMENT']);

        const goBack = () => {
            router.go(-1);
        };

        const goToPage = (path) => {
            router.push(city.value ? `/${city.value.slug}/${path}` : `${path}`);
        };

        const goTo = (path) => {
            if(path == '/catalog-page?freeDelivery=true') {
                router.push(city.value ?`/${city.value.slug}/catalog-list-mobile?freeDelivery=true` : '/catalog-list-mobile?freeDelivery=true');
                return;
            }
            router.push(city.value ? `/${city.value.slug}${path}` : path);
        };
        
        const showModal = (value) => {
            activeAdv.value = value;
            showAdvModal.value = true;
        };

        const copy = (value) => {
            copyToClipboard(value);
        };

        onMounted(() => {
            modifyAdvert.value = advertisment.value.result.filter((item) => item.title != 'Оптика' && item.title != 'Ортопедия' && item.title != 'Электронные рецепты' && item.title != 'Средства реабилитации в салонах ортопедии' && item.title != 'Товары для красоты: VICHY, LA ROCHE-POSAY, GELTEK, BIODERMA, EMOLIUM, LIBRE DERM');
        });

        return {
            goBack,
            advertisment,
            goTo,
            goToPage,
            showModal,
            copy,
            showAdvModal,
            activeAdv,
            city,
            modifyAdvert,
        };
    },
};
</script>

<style lang="scss" scoped>
.adv-badge-wrap {
    position: absolute;
    top: 8px;
    right: 8px;
}

.adv-badge {
    border-radius: 10px;
    background: $secondary;
    padding: 2px 4px;
    right: 8px;
    top: 8px;
}

.bottom-popup-mobile {
    border-radius: $mobile-border-radius $mobile-border-radius 0 0 !important;
    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.15);
    padding-bottom: calc(8px + constant(safe-area-inset-bottom));
    padding-bottom: calc(8px + env(safe-area-inset-bottom));
}

.adv-wrapper {
    padding-bottom: calc(66px + constant(safe-area-inset-bottom));
    padding-bottom: calc(66px + env(safe-area-inset-bottom)); 
}
</style>
